import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "./scoped-merchant-client";

export const useBriefBuilder = (product: string) => {
  const scope = useScopedMerchantClient();

  return useQuery({
    queryKey: ["brief-builder", scope.merchantId, scope.workspaceId, product],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"]["brief-builder"].$get({
            param: scope.param,
            query: {
              product,
            },
          })
        : await client.merchant[":merchantId"]["brief-builder"].$get({
            param: scope.param,
            query: {
              product,
            },
          });

      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!scope.merchantId && !!product,
  });
};

export type AvailableProduct = {
  productId: string;
  productName: string;
  thumbnail: string | null;
};

export const useAvailableBriefProducts = () => {
  const scope = useScopedMerchantClient();

  return useQuery({
    queryKey: ["brief-builder-available-products", scope.merchantId, scope.workspaceId],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"]["brief-builder"]["available-products"].$get({
            param: scope.param,
          })
        : await client.merchant[":merchantId"]["brief-builder"]["available-products"].$get({
            param: scope.param,
          });

      if (!res.ok) throw await handleError(res);
      const data = await res.json();
      return data.products as AvailableProduct[];
    },
    enabled: !!scope.merchantId,
  });
};
